<template>
    <v-navigation-drawer
            fixed
            v-model="show"
            app

            :clipped="clipped"
            >
            <v-list dense>
                <template v-for="(item,i) in menu">
                    <!-- Single item -->
                    <v-list-item
                        v-if="!item.items"
                        :value="item|isActive"
                        @click="navigate(item)"
                        :key="i"
                        :href="item.url"
                        v-bind="item.bind||{}"
                        >
                        <v-list-item-action>
                            <v-icon v-if="item.icon" v-text="item.icon"  :color="item.color"></v-icon>
                        </v-list-item-action>
                        <v-list-item-content :class="item.color && item.color+'--text'">
                            <v-list-item-title v-text="item.name" ></v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <!-- Group item -->
                    <v-list-group v-else
                            :key="i"
                            :prepend-icon="item.icon"
                            no-action
                            v-bind="item.bind||{}"
                            >
                            <v-list-item slot="activator">
                                <v-list-item-content>
                                    <v-list-item-title v-text="item.name"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-for="(subItem,k) in item.items" v-bind:key="i+'-'+k" @click="navigate(subItem)">
                                <v-list-item-content>
                                    <v-list-item-title v-text="subItem.name"></v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-icon v-if="subItem.icon" v-text="subItem.icon"></v-icon>
                                </v-list-item-action>
                            </v-list-item>
                    </v-list-group>
                </template>
            </v-list>
    </v-navigation-drawer>
</template>
<script>
import {mapGetters} from 'vuex'; //Vuex getter map

export default {
        props: {
            clipped:{type:Boolean,default:false},
            value:{required:true}
        },
        computed: {
            show:{
                get(){return this.value;},
                set(v){this.$emit('input',v);}
            },
            ...mapGetters({
                menu:'mainMenu',
            })
        },

        methods: {
            navigate(item) {
                //if (item.url) location.href = item.url;
            },
        },
        filters:{
            isActive(item){
                return  item.match?
                            location.pathname.match(new RegExp(item.match)):
                            (item.exact?
                                    ( location.pathname===(item.url) || location.href=== (item.url)|| location.href=== (item.url)+'/'):
                                    ( location.pathname.startsWith(item.url) || location.href.startsWith(item.url))
                            );
            },
        }
    }
</script>
